import { getFileNameFromURL } from "../../../utils/generalUtils";

export const promotionInitialState = (values, setImgUpload, setPdfFile) => {
  // a promotion whose images/document were all removed still keeps its own details
  if (!values) {
    return {
      bannerFile: "",
      description: "",
      endDate: "",
      startDate: "",
      documentFiles: [],
      imageFiles: [],
      title: "",
      vendorEmail: "",
    };
  }

  const promotionalOffersOthers = values.PromotionalOffersOthers || [];
  const imageUrlsArray = promotionalOffersOthers.filter(
    (d) => d.documentType === "IMAGE"
  ).map((d) => ({
    fileName: getFileNameFromURL(d?.documentPath),
    imageUrl: d?.documentPath,
    promotionalOfferId: d?.promotionalOfferId,
    id: d?.id,
  }));
  const documentUrlsArray =
    promotionalOffersOthers.find((d) => d.documentType === "DOCUMENT")
      ?.documentPath || null;
  const isBanner = promotionalOffersOthers.findIndex(
    (d) => d.isBanner === true
  );
  const isBannerName = getFileNameFromURL(
    promotionalOffersOthers[isBanner]?.documentPath
  );
  return {
    bannerFile: isBanner,
    description: values?.description || "",
    endDate: values?.endDate || "",
    startDate: values?.startDate || "",
    documentFiles: documentUrlsArray,
    imageFiles: imageUrlsArray,
    title: values?.title || "",
    isBannerName: isBannerName || " ",
    vendorEmail: values?.vendorEmail || "",
  };
};
export const CustomInput = ({ value, onClick, placeholder }) => (
  <input
    type="text"
    value={value}
    onClick={onClick}
    readOnly 
    className="form-control"
    placeholder={placeholder}
  />
);
